module.exports = __webpack_public_path__ + "assets/b76a8db2b3d7b6ccbb7d1d6b41fe61a0.mp3";